import {
  keepPreviousData,
  useQuery,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { serviceApi } from "@/api/services/services";
import type {
  ServiceSearchParams,
  ServiceCreate,
  ServiceUpdate,
} from "@/types/services/api-types/service-types";

export const useGetServicesPaginated = (params: ServiceSearchParams = {}) => {
  return useQuery({
    queryKey: ["services", params],
    queryFn: () => serviceApi.getServices(params),
    placeholderData: keepPreviousData,
  });
};

export const useCreateService = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ServiceCreate) => serviceApi.createService(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
    },
  });
};

export const useUpdateService = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: ServiceUpdate }) =>
      serviceApi.updateService(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
    },
  });
};

export const useDeleteService = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => serviceApi.deleteService(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
    },
  });
};
